module.exports = __webpack_public_path__ + "img/av036.2e33027b.png";